// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"141":"6ffaff5a","371":"1a50fc8e","373":"093bf22a","392":"b087632a","493":"b89ec07e","570":"1cabd671","655":"d9c2d420","921":"2baefffd","947":"8e727b6f","983":"5b3332e6"}[chunkId] + ".js";
};